<template>
<b-modal ref="addItem" title="Tilføj">
  <form @submit.prevent="write">
    <div class="form-group">
      <label>Kategori:</label>
      <input v-model="item.category" type="text" class="form-control">
      <label>Gruppe:</label>
      <input v-model="item.group" type="text" class="form-control">
      <label>Type:</label>
      <input v-model="item.type" type="text" class="form-control">
      <label>Beskrivelse:</label>
      <textarea v-model="item.description" class="form-control" />
      <label>Pris:</label>
        <input
          v-model="item.price"
          type="text"
          class="form-control" >
      </div>
    </form>
    <template slot="modal-footer">
      <b-button
        variant="success"
        size="sm"
        @click="write()">Gem
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  db
} from '../../config/firebase';

export default {
  name: 'AddItem',
  components: {},
  data() {
    return {
      item: {
        category: '',
        group: '',
        type: '',
        description: '',
        price: ''
      }
    }
  },
  firebase: {
    products: db.ref('products')
  },
  methods: {
    write() {
      this.$firebaseRefs.products.push({
        category: this.item.category,
        group: this.item.group,
        type: this.item.type,
        description: this.item.description,
        price: this.item.price
      })
      this.item.category = ''
      this.item.group = ''
      this.item.type = ''
      this.item.description = ''
      this.item.price = ''
      this.$refs.addItem.hide()
    },
    show() {
      this.$refs.addItem.show()
    }
  }
}
</script>

<style scoped>
</style>
